import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { User } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {
    "& h5": {
      marginTop: 32,
      marginBottom: 25,
      fontSize: 17,
      fontWeight: "bold",
      color: "#000000",
    },
    "& .MuiTypography-body1": {
      marginBottom: 20,
      fontSize: 16,
      fontWeight: 500,
      color: "#525252",
    },
    "& textarea": {
      padding: 15,
      marginBottom: 20,
      height: 83,
      width: "100%",
      fontSize: 14,
      color: "#4A4A4A",
      backgroundColor: "transparent",
      border: "1px solid #B8B8B8",
      borderRadius: 3,
    },
    "& .client-list": {
      marginTop: 50,
      fontSize: 16,
      "& .client-name": {
        marginBottom: 0,
        fontWeight: "bold",
        color: "#000000",
        textTransform: "capitalize",
      },
      "& .client-email": {
        marginBottom: 5,
        color: "#525252",
      },
    },
  },
});

export default function SessionShare(props: {
  clients: User.IUserClient[];
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { clients, onSubmit } = props;
  const [toSelf, setToSelf] = React.useState(false);
  const [toCustomer, setToCustomer] = React.useState(false);
  const mapClients = (client: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    photo?: User.IUserPhoto;
  }) => {
    return (
      <li key={client.id}>
        <Typography variant="body1" className="client-name" noWrap>
          {client.first_name} {client.last_name}{" "}
        </Typography>
        <Typography variant="body2" className="client-email" noWrap>
          {client.email}
        </Typography>
      </li>
    );
  };
  React.useEffect(() => {
    const submitBtn = document.getElementById("submit-share") as HTMLButtonElement | null;
    if (!submitBtn) return;
    if ((toSelf || toCustomer) && submitBtn.hasAttribute("disabled")) {
      submitBtn.classList.toggle("Mui-disabled", false);
      return submitBtn.removeAttribute("disabled");
    }
    if (!toSelf && !toCustomer && !submitBtn.hasAttribute("disabled")) {
      submitBtn.classList.toggle("Mui-disabled", true);
      return submitBtn.setAttribute("disabled", "true");
    }
  }, [toSelf, toCustomer]);
  return (
    <Container className={classes.container}>
      <form id="session-share" onSubmit={onSubmit}>
        <input
          readOnly
          type="text"
          id="to_self"
          name="to_self"
          value={`${toSelf}`}
          style={{ display: "none" }}
        />
        <Typography variant="h5">
          {t("Send PDF copy to my email")}
          <span
            className={toSelf ? "toggle-container toggled" : "toggle-container"}
            onClick={() => setToSelf(!toSelf)}
          >
            <span className="toggle-button" />
          </span>
        </Typography>
        <Typography variant="body1">{t("Message")}</Typography>
        <textarea id="message" placeholder={t("Message")} name="message" />
        <input
          readOnly
          type="text"
          id="to_customer"
          name="to_customer"
          value={`${toCustomer}`}
          style={{ display: "none" }}
        />
        <Typography variant="h5">
          {t("Send PDF to the clients below")}
          <span
            className={toCustomer ? "toggle-container toggled" : "toggle-container"}
            onClick={() => setToCustomer(!toCustomer)}
          >
            <span className="toggle-button" />
          </span>
        </Typography>
        <div className="client-list">
          <ul>{clients.map(mapClients)}</ul>
        </div>
      </form>
    </Container>
  );
}
